import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, CircularProgress, Alert } from '@mui/material';

const JsonTreeModal = ({ open, onClose, qualificationId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (open && qualificationId) {
      fetchJsonTree();
    }
  }, [open, qualificationId]);

  const fetchJsonTree = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/qualifications/${qualificationId}/json-tree`);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const result = await response.json();
      setData(result);
    } catch (err) {

      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="json-tree-modal-title"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: '1200px',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          overflow: 'auto'
        }}
      >
        <Typography id="json-tree-modal-title" variant="h5" component="h2" gutterBottom>
          JSON Tree - Qualification {qualificationId}
        </Typography>

        {loading && (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {data && !loading && (
          <>
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" color="text.secondary">
                <strong>Sanitized File:</strong> {data.sanitized_file}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>File Size:</strong> {(data.sanitized_size / 1024).toFixed(2)} KB
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Total Modules:</strong> {data.tree.modules.length}
              </Typography>
            </Box>

            <Box
              sx={{
                maxHeight: '60vh',
                overflow: 'auto',
                border: '1px solid #ddd',
                borderRadius: 1,
                p: 2,
                backgroundColor: '#f5f5f5',
                fontFamily: 'monospace',
                fontSize: '12px',
                whiteSpace: 'pre-wrap'
              }}
            >
              <pre>{JSON.stringify(data.tree, null, 2)}</pre>
            </Box>
          </>
        )}

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose} variant="contained">
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default JsonTreeModal;
